import React, { useState } from 'react';
import { TrendingUp, DollarSign, Calendar, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const EarningsDashboard = ({ earnings }) => {
  const navigate = useNavigate();

  const data = {
    today: earnings?.today ?? 0,
    week: earnings?.week ?? 0,
    month: earnings?.month ?? 0,
    pending: earnings?.pending ?? 0,
  };

  const maxVal = Math.max(data?.today, data?.week / 7, data?.month / 30, 1);

  const bars = [
    { label: 'Today', value: data?.today, color: 'bg-[#ffd700]' },
    { label: 'This Week', value: data?.week, color: 'bg-[#2d5a87]' },
    { label: 'This Month', value: data?.month, color: 'bg-[#1a365d]' },
  ];

  return (
    <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-[#1a365d]" />
          <h3 className="font-semibold text-[#1a365d]">Earnings Dashboard</h3>
        </div>
        <button
          onClick={() => navigate('/payments-wallet-screen')}
          className="flex items-center gap-1 text-xs text-[#2d5a87] font-medium hover:text-[#1a365d] transition-colors"
        >
          Full History <ChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="p-5">
        <div className="grid grid-cols-3 gap-3 mb-5">
          {[
            { label: 'Today', value: data?.today, icon: DollarSign, bg: 'bg-[#ffd700]/10', text: 'text-[#d97706]' },
            { label: 'This Week', value: data?.week, icon: Calendar, bg: 'bg-[#2d5a87]/10', text: 'text-[#2d5a87]' },
            { label: 'This Month', value: data?.month, icon: TrendingUp, bg: 'bg-[#1a365d]/10', text: 'text-[#1a365d]' },
          ]?.map(({ label, value, icon: Icon, bg, text }) => (
            <div key={label} className={`${bg} rounded-xl p-3.5 text-center`}>
              <div className={`w-7 h-7 ${bg} rounded-lg flex items-center justify-center mx-auto mb-1.5`}>
                <Icon className={`w-3.5 h-3.5 ${text}`} />
              </div>
              <p className="text-lg font-bold text-[#1a365d]">{value?.toLocaleString()}</p>
              <p className="text-xs text-slate-500">{label}</p>
            </div>
          ))}
        </div>

        {/* Mini bar chart */}
        <div className="space-y-2.5">
          {bars?.map(({ label, value, color }) => (
            <div key={label} className="flex items-center gap-3">
              <span className="text-xs text-slate-500 w-20 flex-shrink-0">{label}</span>
              <div className="flex-1 bg-slate-100 rounded-full h-2.5 overflow-hidden">
                <div
                  className={`${color} h-full rounded-full transition-all duration-700`}
                  style={{ width: `${Math.min((value / (maxVal * 30)) * 100, 100)}%` }}
                />
              </div>
              <span className="text-xs font-semibold text-slate-700 w-16 text-right">KSh {value?.toLocaleString()}</span>
            </div>
          ))}
        </div>

        {data?.pending > 0 && (
          <div className="mt-4 bg-amber-50 border border-amber-200 rounded-xl px-4 py-2.5 flex items-center justify-between">
            <span className="text-sm text-amber-700">Pending Payout</span>
            <span className="text-sm font-bold text-amber-800">KSh {data?.pending?.toLocaleString()}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EarningsDashboard;
